import { useActiveCompany } from './useActiveCompany'

/** Whether a company is an autotax customer still waiting on the accountant's verdict. */
export function isOnboardingBlockedForCompany(company: CompaniesItem | undefined): boolean {
  if (!company) {
    return false
  }

  return company.service_type === 'autotax' && company.autotax_status !== 'approved'
}

/** The same question for the company the app is currently scoped to. */
export function useIsOnboardingBlocked(): boolean {
  return isOnboardingBlockedForCompany(useActiveCompany())
}
